import { g as getOriginalSource, a as getOriginalLandingPage } from "../../../analytics-plugin-original-source.browser.es-e6f690eb.js";
import { EVENT_FIELDS } from "../../constants/analytics.es.js";
import { g as getRootDomain } from "../../../cookies-04bd2321.js";
import { getUtmParams } from "./getUtmParams.es.js";
import { m as mapKeys } from "../../../mapKeys-251205e5.js";
import { p as pickFields } from "../../../pickFields-27454ddf.js";
import "../../../utils/logger.es.js";
const extractUrlData = (payload) => {
  var _a;
  const originalSources = mapKeys(
    (key) => "original_utm_" + key,
    getOriginalSource()
  );
  const domain = typeof window !== "undefined" ? (_a = window == null ? void 0 : window.location) == null ? void 0 : _a.hostname : void 0;
  const rootDomain = domain ? getRootDomain(domain) : void 0;
  const { properties = {} } = payload;
  const { search, path, hash } = properties;
  const picked = pickFields([EVENT_FIELDS.URL], payload.properties);
  return {
    ...domain && { domain },
    ...rootDomain && { root_domain: rootDomain },
    ...picked,
    ...originalSources,
    ...getUtmParams(search),
    [EVENT_FIELDS.URL_PATH]: path,
    [EVENT_FIELDS.URL_SEARCH]: search,
    [EVENT_FIELDS.URL_HASH]: hash,
    [EVENT_FIELDS.ORIGINAL_LANDING_PAGE]: getOriginalLandingPage()
  };
};
export {
  extractUrlData
};
